import { Add, Close } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { Box, Button, IconButton, InputLabel, Typography } from '@mui/material';
import { Loader } from 'components';
import SelectUser from 'components/SelectUser';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import OrderWorkunit from 'types/entities/OrderWorkunit';
import User from 'types/entities/User';
import Order from 'types/entities/Order';
// import './OrderWorkunitAffectationEdit.scss';

type Props = {
  consultants?: User[];
  customers?: User[];
  deliveryManagers?: User[];
  order: Order | null;
  validateSelectedOptions: (multiSelect: Partial<OrderWorkunit>) => void;
  isLoading: boolean;
  dispatchOpen: React.DispatchWithoutAction;
};

const OrderWorkunitAffectationEdit: React.FC<Props> = ({
  consultants,
  customers,
  deliveryManagers,
  order,
  validateSelectedOptions,
  isLoading,
  dispatchOpen,
}) => {
  const [selectedOptions, setSelectedOptions] = useState<Partial<OrderWorkunit>>({});

  // let filteredCustomer = customers;
  let filteredConsultants = consultants;
  let filteredDeliveryManagers = deliveryManagers;

  // if (order?.client) {
  //   filteredCustomer = customers?.filter((data) => data.id === order?.client?.id);
  // }

  if (order?.tmconsultants) {
    const idsToFilter = order?.tmconsultants.map((data) => data.id);
    filteredConsultants = consultants?.filter((data) => idsToFilter.includes(data.id));
  }

  if (order?.tmaccountables) {
    const idsToFilter = order?.tmaccountables.map((data) => data.id);
    filteredDeliveryManagers = deliveryManagers?.filter((data) => idsToFilter.includes(data.id));
  }

  const [t] = useTranslation();
  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 5 }}>
        <Typography variant="h2">{t('Edit_Order_Workunit')}</Typography>
        <IconButton sx={{ ml: 'auto' }} color="primary" onClick={dispatchOpen}>
          <Close />
        </IconButton>
      </Box>

      <>
        <Box sx={{ mb: 3 }}>
          {!filteredConsultants ? (
            <Loader size={20} />
          ) : (
            <SelectUser
              disabled={isLoading}
              users={filteredConsultants}
              selectedUser={selectedOptions.consultant}
              onSelectUser={(user) =>
                setSelectedOptions({
                  ...selectedOptions,
                  consultant_id: user?.id,
                  consultant: user as User | undefined,
                })
              }
              label={t('Consultant')}
            />
          )}
        </Box>

        <Box sx={{ mb: 3 }}>
          {!filteredDeliveryManagers ? (
            <Loader size={20} />
          ) : (
            <SelectUser
              disabled={isLoading}
              users={filteredDeliveryManagers}
              selectedUser={selectedOptions.delivery_manager?.[0]}
              onSelectUser={(user) =>
                setSelectedOptions({
                  ...selectedOptions,
                  delivery_manager_ids: user ? [user.id] : [],
                  delivery_manager: user ? [user] : [],
                })
              }
              label={t('Delivery_Manager')}
            />
          )}
        </Box>

        <Box sx={{ mb: 3 }}>
          {!customers ? (
            <Loader size={20} />
          ) : (
            <SelectUser
              users={customers}
              disabled={isLoading}
              selectedUser={selectedOptions.client}
              onSelectUser={(user) =>
                setSelectedOptions({
                  ...selectedOptions,
                  client_id: user?.id,
                  client: user as User | undefined,
                })
              }
              label={t('Customer Validation')}
            />
          )}
        </Box>
      </>
      <LoadingButton
        variant="contained"
        color="success"
        startIcon={<Add />}
        loading={isLoading}
        onClick={() => validateSelectedOptions(selectedOptions)}
      >
        Submit
      </LoadingButton>
    </>
  );
};

export default OrderWorkunitAffectationEdit;
